import { CategoryRef, Filter } from '~/mappers/itemListing/models';

export enum SORT_BY {
  NAME_ASC = 'name_asc',
  NAME_DESC = 'name_desc',
  RECENT = 'recent',
  DEFAULT = 'default',
}

export type SortBy =
  | SORT_BY.NAME_ASC
  | SORT_BY.NAME_DESC
  | SORT_BY.RECENT
  | SORT_BY.DEFAULT;

export type UseFilterOptions = {
  fields?: {
    name: string;
    updatedAt: string;
  };
  filters?: Filter[];
};

export type HandleFilterChangeType = (
  group: string,
  value: CategoryRef,
  label: string
) => void;
